"use strict";

var _classCallCheck = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Emitters = void 0;

var EmitterInstance_1 = require("./EmitterInstance");

var Emitter_1 = require("./Options/Classes/Emitter");

var Enums_1 = require("./Enums");

var Utils_1 = require("../../Utils");

var Emitters =
/*#__PURE__*/
function () {
  function Emitters(container) {
    var _this = this;

    _classCallCheck(this, Emitters);

    this.container = container;
    this.array = [];
    this.emitters = [];
    this.interactivityEmitters = [];
    var overridableContainer = container;

    overridableContainer.getEmitter = function (idxOrName) {
      return idxOrName === undefined || typeof idxOrName === "number" ? _this.array[idxOrName || 0] : _this.array.find(function (t) {
        return t.name === idxOrName;
      });
    };

    overridableContainer.addEmitter = function (options, position) {
      return _this.addEmitter(options, position);
    };

    overridableContainer.playEmitter = function (idxOrName) {
      var emitter = overridableContainer.getEmitter(idxOrName);

      if (emitter) {
        emitter.externalPlay();
      }
    };

    overridableContainer.pauseEmitter = function (idxOrName) {
      var emitter = overridableContainer.getEmitter(idxOrName);

      if (emitter) {
        emitter.externalPause();
      }
    };
  }

  _createClass(Emitters, [{
    key: "init",
    value: function init(options) {
      var _a, _b;

      if (!options) {
        return;
      }

      if (options.emitters) {
        if (options.emitters instanceof Array) {
          this.emitters = options.emitters.map(function (s) {
            var tmp = new Emitter_1.Emitter();
            tmp.load(s);
            return tmp;
          });
        } else {
          if (this.emitters instanceof Array) {
            this.emitters = new Emitter_1.Emitter();
          }

          this.emitters.load(options.emitters);
        }
      }

      var interactivityEmitters = (_b = (_a = options.interactivity) === null || _a === void 0 ? void 0 : _a.modes) === null || _b === void 0 ? void 0 : _b.emitters;

      if (interactivityEmitters) {
        if (interactivityEmitters instanceof Array) {
          this.interactivityEmitters = interactivityEmitters.map(function (s) {
            var tmp = new Emitter_1.Emitter();
            tmp.load(s);
            return tmp;
          });
        } else {
          if (this.interactivityEmitters instanceof Array) {
            this.interactivityEmitters = new Emitter_1.Emitter();
          }

          this.interactivityEmitters.load(interactivityEmitters);
        }
      }

      if (this.emitters instanceof Array) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.emitters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var emitterOptions = _step.value;
            this.addEmitter(emitterOptions);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else {
        this.addEmitter(this.emitters);
      }
    }
  }, {
    key: "play",
    value: function play() {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.array[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var emitter = _step2.value;
          emitter.play();
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.array[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var emitter = _step3.value;
          emitter.pause();
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      this.array = [];
    }
  }, {
    key: "update",
    value: function update(delta) {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = this.array[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var emitter = _step4.value;
          emitter.update(delta);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    }
  }, {
    key: "handleClickMode",
    value: function handleClickMode(mode) {
      var container = this.container;
      var emitterOptions = this.emitters;
      var modeEmitters = this.interactivityEmitters;

      if (mode === Enums_1.EmitterClickMode.emitter) {
        var emitterModeOptions;

        if (modeEmitters instanceof Array) {
          if (modeEmitters.length > 0) {
            emitterModeOptions = (0, Utils_1.itemFromArray)(modeEmitters);
          }
        } else {
          emitterModeOptions = modeEmitters;
        }

        var emittersOptions = emitterModeOptions !== null && emitterModeOptions !== void 0 ? emitterModeOptions : emitterOptions instanceof Array ? (0, Utils_1.itemFromArray)(emitterOptions) : emitterOptions;
        var ePosition = container.interactivity.mouse.clickPosition;
        this.addEmitter((0, Utils_1.deepExtend)({}, emittersOptions), ePosition);
      }
    }
  }, {
    key: "resize",
    value: function resize() {
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = this.array[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var emitter = _step5.value;
          emitter.resize();
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    }
  }, {
    key: "addEmitter",
    value: function addEmitter(options, position) {
      var emitter = new EmitterInstance_1.EmitterInstance(this, this.container, options, position);
      this.array.push(emitter);
      return emitter;
    }
  }, {
    key: "removeEmitter",
    value: function removeEmitter(emitter) {
      var index = this.array.indexOf(emitter);

      if (index >= 0) {
        this.array.splice(index, 1);
      }
    }
  }]);

  return Emitters;
}();

exports.Emitters = Emitters;